import React from 'react';
import { ChevronDown } from 'lucide-react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import { ProfilePicture } from '@getro/rombo';

const ActiveNetwork = ({ current }) => (
  <Flex alignItems="center" sx={{ gap: '4px' }}>
    <ProfilePicture
      imageUrl={current.logo}
      name={current.name}
      variant="square"
      width="24px"
      height="24px"
      flexShrink="0"
    />
    <Text
      color="text.dark"
      fontWeight="500"
      fontSize="14px"
      overflow="hidden"
      textAlign="left"
      sx={{
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
      }}
    >
      {current.name}
    </Text>

    <Flex alignItems="center" color="text.main" flex="0 0 auto">
      <Box as={ChevronDown} height="16px" width="16px" aria-hidden="true" />
    </Flex>
  </Flex>
);

ActiveNetwork.propTypes = {
  current: PropTypes.shape({
    logo: PropTypes.string,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default ActiveNetwork;
